export default __webpack_public_path__ + "d1e4d7ade7e980cfb6835304df802fca.png";